import { render } from "./OverView.vue?vue&type=template&id=65ff8143&scoped=true"
import script from "./OverView.vue?vue&type=script&lang=js"
export * from "./OverView.vue?vue&type=script&lang=js"

import "./OverView.vue?vue&type=style&index=0&id=65ff8143&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ff8143"]])

export default __exports__